import axios from "axios";
import {BASE_URL} from "../../router/API";
import {authProvider} from "../../authProvider";

export const getRolesTable = (props)=>{
    return axios({
        method:'GET',
        url:'rbac/roles'+props,
        baseURL:BASE_URL,
        headers:{
            'X-Requested-With':'XMLHttpRequest',
            'Authorization' : `Bearer ${authProvider.token}`
        },
        responseType: 'json',
    })
};

export const getPermissionsFilter = ()=>{
    return axios({
        method:'GET',
        url:'rbac/permissions-id-name',
        baseURL:BASE_URL,
        headers:{
            'X-Requested-With':'XMLHttpRequest',
            'Authorization' : `Bearer ${authProvider.token}`
        },
        responseType: 'json',
    })
};

export const getRolePermissions = (roleId)=>{
    return axios({
        method:'GET',
        url:`rbac/roles/${roleId}/permissions`,
        baseURL:BASE_URL,
        headers:{
            'X-Requested-With':'XMLHttpRequest',
            'Authorization' : `Bearer ${authProvider.token}`
        },
        responseType: 'json',
    })
}

export const updateRolePermissions = (roleId,data)=>{
    return axios({
        method:'POST',
        url:`rbac/roles/${roleId}/permissions`,
        baseURL:BASE_URL,
        headers:{
            'X-Requested-With':'XMLHttpRequest',
            'Authorization' : `Bearer ${authProvider.token}`
        },
        data,
        responseType: 'json',
    })
}

export const deleteRolePermissions = (roleId,params)=>{
    return axios({
        method:'DELETE',
        url:`rbac/roles/${roleId}/permissions`+params,
        baseURL:BASE_URL,
        headers:{
            'X-Requested-With':'XMLHttpRequest',
            'Authorization' : `Bearer ${authProvider.token}`
        },
        responseType: 'json',
    })
}